import { ShoppingBag } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { CrossSellEditorRenderer } from "./editor";
import { CrossSellEmailPanelRenderer } from "./email-panel";
import { CrossSellEmailRenderer } from "./email";
import type { CrossSellBlockProps } from "./types";
import { CrossSellWebEditor } from "./web-editor";
import { CrossSellWebRenderer } from "./web";

export default registerBlock<CrossSellBlockProps>({
  type: "cross-sell",
  name: "editorBlocksLibrary.blocks.cross-sell.title",
  description: "editorBlocksLibrary.blocks.cross-sell.description",
  Icon: ShoppingBag,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    email: {
      component: CrossSellEmailRenderer,
      editor: {
        component: CrossSellEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: CrossSellEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: CrossSellWebRenderer,
      editor: {
        component: CrossSellWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: CrossSellEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { CrossSellBlock, CrossSellBlockProps } from "./types";
